import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from './client';

export interface TodoItem {
  id?: number;
  title: string;
  description: string;
  priority: string;
  status: string;
  owner: string;
  due_date: string | null;
  due_time: string;
  is_daily: boolean;
}

export function useTodos(params?: { type?: string; status?: string; month?: string }) {
  return useQuery({
    queryKey: ['todos', params],
    queryFn: async () => {
      const res = await apiClient.get('/todos', { params });
      return res.data;
    },
  });
}

export function useCreateTodo() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (item: TodoItem) => {
      const res = await apiClient.post('/todos', item);
      return res.data;
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ['todos'] }),
  });
}

export function useUpdateTodo() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, ...item }: TodoItem & { id: number }) => {
      const res = await apiClient.put(`/todos/${id}`, item);
      return res.data;
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ['todos'] }),
  });
}

export function useDeleteTodo() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (id: number) => {
      const res = await apiClient.delete(`/todos/${id}`);
      return res.data;
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ['todos'] }),
  });
}

export function useBulkImportTodos() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (items: TodoItem[]) => {
      const res = await apiClient.post('/todos/bulk', { items });
      return res.data;
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ['todos'] }),
  });
}
